export default [
    {
        path: '/warehouse/warehouse-receiving',
        name: 'warehouse-receiving',
        props: true,
        component: () => import('@/views/warehouse/warehouse-receiving/index.vue'),
        meta: {
            pageTitle: 'Receiving',
            breadcrumb: [
                {
                text: 'Receiving',
                active: true,
                },
            ],
        },
    },
    {
        path: '/warehouse/warehouse-receiving/:id',
        name: 'detail-warehouse-receiving',
        props: true,
        component: () => import('@/views/warehouse/warehouse-receiving/detail.vue'),
        meta: {
            pageTitle: 'Detail Receiving',
            breadcrumb: [
                {
                text: 'Receiving',
                to: { name: 'warehouse-receiving' },
                },
                {
                text: 'Detail Receiving',
                active: true,
                },
            ],
        },
    },
]